import { CANVAS_ELEMENT_HIGHLIGHT } from '../PreviewDisplayConstants';

// The red and white striped line every piece of canvas element chrome is drawn with: the bounding
// indicator, and the guides that appear when a drag catches on an alignment line.
//
// It is a background gradient rather than a dashed border because a dash leaves gaps that the backdrop
// shows through, so a dashed red line disappears against a red photo. Alternating red and white
// segments always leave one of the two readable, whatever is underneath.
//
// `direction` is a CSS gradient angle: '90deg' runs the segments left to right, '180deg' top to bottom.
export function buildLinedGradient(direction) {
    const { LINE_COLOR, ALTERNATE_LINE_COLOR, LINE_SEGMENT_LENGTH } = CANVAS_ELEMENT_HIGHLIGHT;

    return `repeating-linear-gradient(${direction},`
        + ` ${LINE_COLOR} 0 ${LINE_SEGMENT_LENGTH}px,`
        + ` ${ALTERNATE_LINE_COLOR} ${LINE_SEGMENT_LENGTH}px ${LINE_SEGMENT_LENGTH * 2}px)`;
}
